module.exports = __webpack_public_path__ + "assets/img/79df59fdcd7677b8aa5100f8c557c487.png";